import PropTypes from 'prop-types';
import { ItemsAll } from '../../components/Views/ItemsAll';
import { getSeoData, getValueFromObject } from '../../utils/helpers';
import Layout from '../../components/Layout/Layout';
import { getDataForTransformationsQuery } from '../../queries';
import {
  setAdriverSelectedCity,
  setCurrentState,
  setSearchSort
} from '../../actions';
import { BUILDING_TYPE_ID, Cities } from '../../utils/helpers/constants';
import { getStaticData } from '../../utils/helpers/getStaticData';

const App = ({ sortingValue, ...rest }) => (
  <ItemsAll {...{ sortingValue, ...rest }} />
);

App.getInitialProps = async ({ apolloClient, asPath, req, query, store }) => {
  const [dataForTransform, staticData, seoData] = await Promise.all([
    apolloClient.query({ query: getDataForTransformationsQuery }),
    getStaticData(apolloClient, true),
    getSeoData(apolloClient, asPath, req)
  ]);

  const sortingValue = query.sorting;

  const sortingId = getValueFromObject(
    dataForTransform.data.sort,
    sortingValue,
    'id'
  );
  const sortingName = getValueFromObject(
    dataForTransform.data.sort,
    sortingValue,
    'name'
  );

  const storedFormState = store.getState().searchForm.currentState;
  store.dispatch(
    setCurrentState({
      ...storedFormState,
      city_id: Cities.Baku.id,
      category_id: BUILDING_TYPE_ID.FLAT_NEW,
      leased: 'false'
    })
  );
  store.dispatch(setAdriverSelectedCity(Cities.Baku.az));

  store.dispatch(setSearchSort(sortingId || '1'));

  return { sortingValue: sortingName, seoData, ...staticData };
};

App.propTypes = {
  sortingValue: PropTypes.string,
  citiesUnPopularList: PropTypes.array,
  regions: PropTypes.object,
  categories: PropTypes.array
};

App.getLayout = (page, pageProps) => (
  <Layout isBackgroundBanner pageProps={pageProps}>
    {page}
  </Layout>
);

export default App;
